"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPDF = void 0;
var logic_1 = require("./logic");
var video_1 = require("./video");
var setupPDF = function () {
    var _a;
    var _b = (0, logic_1.getInputVals)(), name = _b.name, currentSavings = _b.currentSavings, monthlySavings = _b.monthlySavings, monthlySavings10 = _b.monthlySavings10, monthlySavings20 = _b.monthlySavings20, goal = _b.goal, savingsReason = _b.savingsReason, normalTime = _b.normalTime, time10 = _b.time10, time20 = _b.time20;
    var goalVal = (0, video_1.formatCurrency)(goal, 0);
    var monthSavingVal = (0, video_1.formatCurrency)(monthlySavings, 0);
    var currentSavingVal = (0, video_1.formatCurrency)(currentSavings, 0);
    var regTime = (0, video_1.convertToYears)(0);
    var p10Time = (0, video_1.convertToYears)(0.1);
    var p20Time = (0, video_1.convertToYears)(0.2);
    var savingGoalReason = String(document.getElementById("saving-reason").querySelectorAll("option")[document.getElementById("saving-reason").selectedIndex].textContent).toLowerCase();
    //Different conditional text blocks
    var savingY = "<div class=\"yes-savings\">\n                        <p><span class=\"pdf-name fw-bold\">".concat(name, "</span>, your goal is to save <span class=\"savings-end-goal fw-bold\">").concat(goalVal, "</span> and you already have <span id=\"already-saved\" class=\"fw-bold\">").concat(currentSavingVal, "</span> saved.</p>\n                        <p>By paying yourself <span class=\"saving-per-month-in-sentance fw-bold\">").concat(monthSavingVal, "</span> each month it will take <span class=\"length-of-time fw-bold\">").concat(regTime, "</span> for you to reach your goal of saving for your <span class=\"pdf-savings-goal fw-bold\">").concat(savingGoalReason, "</span>.</p>\n                    </div>");
    var savingN = "<div class=\"no-savings\">\n                        <p><span class=\"pdf-name fw-bold\">".concat(name, "</span>, your goal is to save <span class=\"savings-end-goal fw-bold\">").concat(goalVal, "</span> and by paying yourself <span class=\"saving-per-month-in-sentance fw-bold\">").concat(monthSavingVal, "</span> each month it will take <span class=\"length-of-time fw-bold\">").concat(regTime, "</span> for you to reach your goal of saving for your <span class=\"pdf-savings-goal fw-bold\">").concat(savingGoalReason, "</span>.</p>\n                    </div>");
    var savingYother = "<div class=\"yes-savings\">\n                        <p><span class=\"pdf-name fw-bold\">".concat(name, "</span>, your goal is to save <span class=\"savings-end-goal fw-bold\">").concat(goalVal, "</span> and you already have <span id=\"already-saved\" class=\"fw-bold\">").concat(currentSavingVal, "</span> saved.</p>\n                        <p>By paying yourself <span class=\"saving-per-month-in-sentance fw-bold\">").concat(monthSavingVal, "</span> each month it will take <span class=\"length-of-time fw-bold\">").concat(regTime, "</span> for you to reach your <span class=\"fw-bold\">savings goal</span>.</p>\n                    </div>");
    var savingNother = "<div class=\"no-savings\">\n                        <p><span class=\"pdf-name fw-bold\">".concat(name, "</span>, your goal is to save <span class=\"savings-end-goal fw-bold\">").concat(goalVal, "</span> and by paying yourself <span class=\"saving-per-month-in-sentance fw-bold\">").concat(monthSavingVal, "</span> each month it will take <span class=\"length-of-time fw-bold\">").concat(regTime, "</span> for you to reach your <span class=\"fw-bold\">savings goal</span>.</p>\n                    </div>");
    // Setup Date
    document.querySelector(".print-page-date").innerHTML = getFormattedDate();
    document.querySelectorAll(".pdf-name").forEach(function (el) {
        el.innerHTML = name;
    });
    // document.querySelectorAll(".savings-end-goal").forEach((el) => {
    //     el.innerHTML = goalVal;
    // });
    document.querySelectorAll(".saving-per-month-in-sentance").forEach(function (el) {
        el.innerHTML = (0, video_1.formatCurrency)(monthlySavings, 0);
    });
    document.querySelectorAll(".saving-per-month").forEach(function (el) {
        el.innerHTML = (0, video_1.formatCurrency)(monthlySavings, 0);
    });
    // document.querySelector(".pdf-savings-goal")!.innerHTML =
    //     savingsReason == "other" ? "savings goal" : savingGoalReason;
    // document.getElementById("already-saved")!.innerHTML = formatCurrency(currentSavings, 0);
    document.getElementById("number-of-months").innerHTML =
        regTime.indexOf("year") > 0 ? regTime.split("years")[0] : normalTime;
    if (regTime.indexOf("year") > 0)
        document.querySelector(".reg-time-duration").innerHTML = regTime.replace(/^[\d\s]+/, "");
    document.getElementById("savings-per-month-10").innerHTML = getMonthlySavings10();
    document.getElementById("number-of-months-10").innerHTML =
        p10Time.indexOf("year") > 0 ? p10Time.split("years")[0] : time10;
    if (p10Time.indexOf("year") > 0)
        document.querySelector(".p10-time-duration").innerHTML = p10Time.replace(/^[\d\s]+/, "");
    document.getElementById("savings-per-month-20").innerHTML = getMonthlySavings20();
    document.getElementById("number-of-months-20").innerHTML =
        p20Time.indexOf("year") > 0 ? p20Time.split("years")[0] : time20;
    if (p20Time.indexOf("year") > 0)
        document.querySelector(".p20-time-duration").innerHTML = p20Time.replace(/^[\d\s]+/, "");
    if (Number(currentSavings) > 0 && savingsReason == "other")
        document.getElementById("saving_condition").innerHTML = savingYother;
    else if (Number(currentSavings) > 0 && savingsReason !== "other")
        document.getElementById("saving_condition").innerHTML = savingY;
    else if (Number(currentSavings) == 0 && savingsReason == "other")
        document.getElementById("saving_condition").innerHTML = savingNother;
    else
        document.getElementById("saving_condition").innerHTML = savingN;
    document.querySelector(".length-of-time-plus10").innerHTML = p10Time;
    document.querySelector(".length-of-time-plus20").innerHTML = p20Time;
    (_a = document.querySelector(".goal-icon .goal-".concat(savingsReason, "-icon"))) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
    // Function to return date like this "January 15th, 2025"
    function getFormattedDate() {
        var today = new Date();
        var options = { month: "long", day: "numeric", year: "numeric" };
        var day = today.getDate();
        // const suffix =
        //     day % 10 === 1 && day !== 11
        //         ? "st"
        //         : day % 10 === 2 && day !== 12
        //         ? "nd"
        //         : day % 10 === 3 && day !== 13
        //         ? "rd"
        //         : "th";
        var formattedDate = today.toLocaleDateString("en-US", options).replace(/\d+/, "".concat(day));
        return formattedDate;
    }
    function getMonthlySavings10() {
        var inputVals = (0, logic_1.getInputVals)();
        var tenPercent = Math.round(Number(inputVals.monthlySavings) * 0.1);
        var total = tenPercent + Number(inputVals.monthlySavings);
        return (0, video_1.formatCurrency)(String(total), 0);
    }
    function getMonthlySavings20() {
        var inputVals = (0, logic_1.getInputVals)();
        var tenPercent = Math.round(Number(inputVals.monthlySavings) * 0.2);
        var total = tenPercent + Number(inputVals.monthlySavings);
        return (0, video_1.formatCurrency)(String(total), 0);
    }
    function getMonthsToReachGoal() {
        var inputVals = (0, logic_1.getInputVals)();
        var monthlySavings = Number(inputVals.monthlySavings);
        var currentSavings = Number(inputVals.currentSavings);
        var savingsGoal = Number(inputVals.goal);
        return Math.ceil((savingsGoal - currentSavings) / monthlySavings);
    }
    function getMonthsToReachGoalPercent(percentToIncrease) {
        var inputVals = (0, logic_1.getInputVals)();
        var percent = Math.round(Number(inputVals.monthlySavings) * percentToIncrease);
        var monthlySavings = percent + Number(inputVals.monthlySavings);
        var currentSavings = Number(inputVals.currentSavings);
        var savingsGoal = Number(inputVals.goal);
        return Math.ceil((savingsGoal - currentSavings) / monthlySavings);
    }
};
exports.setupPDF = setupPDF;
//# sourceMappingURL=module.js.map